import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-069-pie graph",
  "use": "icon-069-pie graph-usage",
  "viewBox": "0 0 438.697 438.697",
  "content": "<symbol viewBox=\"0 0 438.697 438.697\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-069-pie graph\"><g><g><path d=\"m438.697 230.717c0-121.76-98.705-220.465-220.465-220.465v220.465z\" fill=\"#27a2db\" /><path d=\"m218.233 230.717-124.595 124.595c32.975 33.173 77.821 51.823 124.595 51.817z\" fill=\"#e1e6e9\" /><path d=\"m218.233 428.445c52.439.062 102.74-20.777 139.769-57.908l-139.769-139.82z\" fill=\"#fcd462\" /><path d=\"m218.233 230.717 124.545 124.595c33.118-32.997 51.696-77.845 51.614-124.595z\" fill=\"#e1e6e9\" /><path d=\"m218.233 230.717h-218.233c-.071 57.905 22.943 113.449 63.948 154.336z\" fill=\"#44c4a1\" /><path d=\"m93.637 106.172c-33.086 32.997-51.66 77.817-51.614 124.544h176.209v-176.159c-46.745-.06-91.586 18.517-124.595 51.615z\" fill=\"#3a556a\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/069-pie graph.svg
// module id = ZjDn
// module chunks = 102